import { supabase } from "../lib/supabase";

export async function createReferral({
  referrerUserId,
  referrerRole,
  referredUserId,
  referredRole,
  referralCode,
}) {
  const { error } = await supabase.from("referrals").insert({
    referrer_user_id: referrerUserId,
    referrer_role: referrerRole,
    referred_user_id: referredUserId,
    referred_role: referredRole,
    referral_code: referralCode,
    status: "pending",
  });

  if (error) throw error;
  return true;
}

export async function fetchMyReferrals(userId) {
  const { data, error } = await supabase
    .from("referrals")
    .select("*")
    .eq("referrer_user_id", userId)
    .order("created_at", { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function fetchMyRewards(userId) {
  const { data, error } = await supabase
    .from("reward_ledger")
    .select("*")
    .eq("user_id", userId)
    .order("created_at", { ascending: false });

  if (error) throw error;
  return data || [];
}

function isMissingRewardsInfra(error) {
  if (!error) return false;

  return (
    error.code === "PGRST204" ||
    error.code === "42P01" ||
    /relation .* does not exist/i.test(error.message || "") ||
    /function .* does not exist/i.test(error.message || "") ||
    /column .* does not exist/i.test(error.message || "")
  );
}

export async function lockBookingMbCredits({
  userId,
  orderId,
  serviceBookingId,
  eligibleLabourSubtotal,
  earnRate,
  creditAmount,
  holdHours = 48,
  expiryDays = 60,
  metadata = {},
}) {
  if (!userId || !serviceBookingId || Number(creditAmount || 0) <= 0) {
    return null;
  }

  const { data, error } = await supabase.rpc("mb_lock_booking_credits", {
    p_user_id: userId,
    p_order_id: orderId || null,
    p_service_booking_id: serviceBookingId,
    p_eligible_labour_subtotal: Number(eligibleLabourSubtotal || 0),
    p_earn_rate: Number(earnRate || 0),
    p_credit_amount: Number(creditAmount || 0),
    p_hold_hours: holdHours,
    p_expiry_days: expiryDays,
    p_reason_code: "booking_reward",
    p_metadata: metadata,
  });

  if (error) {
    if (isMissingRewardsInfra(error)) return null;
    throw error;
  }

  return data || null;
}

export async function fetchMbWallet(userId) {
  if (!userId) return null;

  const { data, error } = await supabase
    .from("mb_wallets")
    .select("*")
    .eq("user_id", userId)
    .eq("wallet_type", "customer")
    .maybeSingle();

  if (error) {
    if (isMissingRewardsInfra(error)) return null;
    throw error;
  }

  return data || null;
}

export async function fetchMbCreditLedger(userId, limit = 50) {
  const wallet = await fetchMbWallet(userId);
  if (!wallet?.id) return [];

  const { data, error } = await supabase
    .from("mb_credit_ledger")
    .select("*")
    .eq("wallet_id", wallet.id)
    .order("created_at", { ascending: false })
    .limit(limit);

  if (error) {
    if (isMissingRewardsInfra(error)) return [];
    throw error;
  }

  return data || [];
}
